import React from 'react';

import Logo from 'components/shared/Icon/icons/Logo';
import Text from 'components/shared/Typography/Text';
import i18n from 'i18n';

import s from './index.module.css';

function PoweredBy() {
  return (
    <div className={s.wrapper}>
      <Text className={s.text}>{i18n.t('proposal_content.powered_by')}</Text>
      <Logo className={s.logo} />
    </div>
  );
}

export default PoweredBy;
